import { useVisibleForecastRevenue } from '../context/VisibleItemFinancialsContext';
import type { ItemsTableRow } from '../types';
import { OrgCurrencyCell } from './OrgCurrencyCell';

export const ForecastRevenueCell = ({ row }: { row: ItemsTableRow }) => (
  <OrgCurrencyCell amount={useVisibleForecastRevenue(row.id)} />
);
